import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import _ from 'lodash'
//import TestData from './data'
import UserFilter from '../UserFilter'
import TableFilter from '../TableFilter'
import CommesseComboFilter from '../CommesseComboFilter'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import DataFilter from '../DataFilter'
import PrintButton from '../PrintButton'
import ElaboraButton from '../ElaboraButton'
import LocalDate from '../LocalDate'
import {minutesToHuman} from '../../Helpers'
import FileSaver from 'file-saver';
import PdfButton from '../PdfButton'
import AttivitaPerCommessa from '../../pdf/AttivitaPerCommessa'
import Moment from 'moment';
import PropTypes from 'prop-types';

class ReportAttivita extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: undefined,
            filterInfo: {
                idUtente: client.getCurrentUserId(),
                idCommessa: 0,
                tipo: 'i',
            },
            _loading: false,
            error: null,
            column: null,
            direction: null,
        };
        this.onChangeUserFilter = this.onChangeUserFilter.bind(this)
        this.onChangeCommessaFilter = this.onChangeCommessaFilter.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.pdfExport = this.pdfExport.bind(this)
        this.loadData = this.loadData.bind(this)
    }

    pdfExport(){
        let ce = new AttivitaPerCommessa();
        ce.setTitle("Report Attività");
        ce.setFileName("report-attivita.pdf");
        ce.setOrientationPortrait();
        ce.setFilterDescription(this.getFilterDescription());
        ce.createPdf(this.state.items);
    }

    getFilterDescription(){
        let msg = '';
        msg += 'Periodo dal ' + Moment(this.state.filterInfo.dataStart).format('DD/MM/YYYY') +
            ' al ' + Moment(this.state.filterInfo.dataEnd).format('DD/MM/YYYY');
        msg += ' Utenti: ' + this.state.filterInfo.nomeUtente;
        msg += ' Commesse: ' + this.state.filterInfo.nomeCommessa;
        return msg;
    }
    componentWillUnmount() {
    }

    componentDidMount() {
    }

    onChangeUserFilter(idutente, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idUtente = idutente;
        filterInfo.nomeUtente = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeCommessaFilter(idcommessa, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idCommessa = idcommessa;
        filterInfo.nomeCommessa = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.setState({filterInfo: filter, items:undefined})
    }
    onChangeFilter(data) {
        let filter = this.state.filterInfo;
        filter.keyword = data.keyword;
        this.setState({filterInfo: filter, items: undefined})
    }

    handleSort = clickedColumn => () => {
        const { column, items, direction } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                items: _.sortBy(items, [clickedColumn]),
                direction: 'ascending',
            })

            return
        }

        this.setState({
            items: items.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    }

    loadData() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportAttivita(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa,
            filterInfo.keyword
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    onExportClick(tipo){
        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.exportReportAttivita(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa, tipo, filterInfo.keyword
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'report_attivita.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    render() {
        let i = 1;
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        let numAttivitaTot = 0;
        let durataPesataTot = 0;
        let tableData = null;
        let stampaButton = null;
        let exportExcelButton = null;
        let exportPdfButton = null;
        if (this.state.items !== undefined){
            if (this.state.items.length > 0){
                stampaButton = <PrintButton/>
                exportExcelButton = (<a href="#" onClick={(ev) => (this.onExportClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Excel
                    </div>
                </a>)
                exportPdfButton = (<PdfButton onClick={(ev) => (this.pdfExport())} />)
                tableData = (
                    <div className="ui segment">
                        <h4>Report Attività</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell sorted={this.state.column === 'idCommessa.nome' ? this.state.direction:null} >
                                        Commessa
                                    </Table.HeaderCell>
                                    <Table.HeaderCell sorted={this.state.column === 'idUtente.nome' ? this.state.direction : null} >
                                        Utente
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'numAttivita' ? this.state.direction:null} >
                                        Numero Sessioni
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'durataPesata' ? this.state.direction:null} >
                                        Durata Totale (h:m:s)
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    this.state.items.map((item) => {
                                        numAttivitaTot += item.numAttivita;
                                        durataPesataTot += item.durataPesata;
                                        return <Table.Row key={i++}>
                                            <Table.Cell><label className="ui empty circular label" style={{backgroundColor: item.commessa.colore}}></label> {item.commessa.nomeCompleto}</Table.Cell>
                                            <Table.Cell>{item.utente.username}</Table.Cell>
                                            <Table.Cell  textAlign='center'>{item.numAttivita}</Table.Cell>
                                            <Table.Cell  textAlign='center'>{minutesToHuman(item.durataPesata)}</Table.Cell>
                                        </Table.Row>
                                    })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="2">Totali</Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b>{numAttivitaTot}</b></Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b>{minutesToHuman(durataPesataTot)}</b></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                )
            }
            else {
                tableData = (
                    <div className="ui segment">
                        <h4>Riepilogo Numero Attività e Durata per Commessa ed Utente</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Body>
                                <Table.Row key={1}>
                                    <Table.Cell><h4>Nessun dato disponibile</h4></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
        }


        return (<div className="ui">
            <h3 className="ui top block attached header no-print">
                <i className="clock icon"/> Report Attività
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui one column stackable grid">
                <div className="ui two column grid">
                    <div className="ten wide column">
                        <DataFilter
                            showOption={'specs'}
                            tipo={this.state.filterInfo.tipo}
                            dataDal={this.state.filterInfo.dataStart}
                            dataAl={this.state.filterInfo.dataEnd}
                            fireOnChangeOnStart={true}
                            onChange={this.onChangeData}
                        />
                    </div>
                    <div  className="six wide column">
                        <TableFilter
                            showPopup={true}
                            changeEventOnKeyPress={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra attività per nota..."
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                </div>
                <div className="column">
                    <div className="ui two column grid">
                        <div className="column">
                            <div className="ui two column grid">
                                <div className="column">
                                    <UserFilter
                                        idUtente={this.state.filterInfo.idUtente}
                                        abilitato={client.isCurrentUserAdmin()}
                                        onChange={this.onChangeUserFilter}
                                        dataDal={this.state.filterInfo.dataStart}
                                        dataAl={this.state.filterInfo.dataEnd}
                                    />
                                </div>
                                <div className="column">
                                    <CommesseComboFilter
                                        idCommessa={this.state.filterInfo.idCommessa}
                                        abilitato={true}
                                        onChange={this.onChangeCommessaFilter}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="column">
                            <ElaboraButton text="Elabora" onClick={this.loadData} /> {stampaButton} {exportExcelButton} {exportPdfButton}
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {tableData}
            {loader}
        </div>)
    }
}

ReportAttivita.contextTypes = {
    router: PropTypes.object
}

export default ReportAttivita;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportAttivita.js
 **/